import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LocalStorageService } from '@rtr-factory/utils/services';
import { tap } from 'rxjs/operators';
import { localStorageActions } from './local-storage.actions';

@Injectable()
export class LocalStorageEffects {
  private actions$ = inject(Actions);
  private localStorageService = inject(LocalStorageService);

  setLocalStorageItem$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(localStorageActions.setLocalStorageItem),
        tap(({ key, value }) => {
          const payload = typeof value === 'string' ? value : JSON.stringify(value);

          this.localStorageService.setValue(key, payload);
        }),
      ),
    { dispatch: false },
  );

  removeLocalStorageItem$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(localStorageActions.removeLocalStorageItem),
        tap(({ key }) => this.localStorageService.removeValue(key)),
      ),
    { dispatch: false },
  );
}
